
import { 
  Code, 
  Palette, 
  MessageSquare, 
  BarChart3,
  Globe,
  Zap
} from "lucide-react";
import HeroSection from "@/components/landing/HeroSection";
import ToolsShowcase from "@/components/landing/ToolsShowcase";
import AccessCodeSection from "@/components/landing/AccessCodeSection";
import SocialProof from "@/components/landing/SocialProof";

const LandingPage = () => {
  const tools = [
    {
      icon: Code,
      title: "Web Development",
      description: "Build stunning websites with our drag-and-drop builder and professional templates",
      features: ["Responsive Design", "SEO Optimization", "Custom Code Editor"]
    },
    {
      icon: Palette,
      title: "Graphic Design",
      description: "Create beautiful graphics, logos, and marketing materials with AI-powered tools",
      features: ["AI Image Generation", "Brand Kits", "Social Media Templates"]
    },
    {
      icon: MessageSquare,
      title: "Content Creation",
      description: "Generate engaging content for social media, blogs, and marketing campaigns",
      features: ["AI Writing Assistant", "Social Media Posts", "SEO Content"]
    },
    {
      icon: BarChart3,
      title: "Analytics & SEO",
      description: "Track performance and optimize your digital presence with advanced analytics",
      features: ["Performance Tracking", "SEO Analysis", "Competitor Insights"]
    },
    {
      icon: Globe,
      title: "Digital Marketing",
      description: "Launch effective marketing campaigns across multiple platforms",
      features: ["Email Marketing", "Social Campaigns", "Lead Generation"]
    },
    {
      icon: Zap,
      title: "Automation Tools",
      description: "Automate repetitive tasks and streamline your workflow",
      features: ["Chatbots", "Form Builders", "API Integrations"]
    }
  ];

  const benefits = [
    "Save 10+ hours per week on content creation",
    "Professional results without hiring agencies",
    "All-in-one platform for digital needs",
    "AI-powered tools for better results"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-accent/5">
      <div className="container mx-auto px-4 py-16 max-w-7xl">
        <HeroSection benefits={benefits} />
        <ToolsShowcase tools={tools} />
        <AccessCodeSection />
        <SocialProof />
      </div>
    </div>
  );
};

export default LandingPage;
